const mapAlgoliaAlbumToAlbum = (
	algoliaAlbum: AlgoliaAlbum,
	topTrack: Track
): Album => {
	return {
		number: algoliaAlbum.Id,
		name: algoliaAlbum.Name,
		pillar: algoliaAlbum.Pillar,
		genre: algoliaAlbum.Genre,
		subgenre: algoliaAlbum.SubGenre,
		artworkImageUrl: algoliaAlbum.ArtworkImageUrl,
		catalogue: algoliaAlbum.Catalogue,
		releaseDate: algoliaAlbum.ReleaseDate,
		topTrack: topTrack,
	}
}

export default mapAlgoliaAlbumToAlbum
